import type { WorkspaceCardContextPayload } from "./workspace.card.context";

export const getDefaultWorkspaceCardContext =
  (): WorkspaceCardContextPayload => ({
    isFavorite: false,
  });
